import { Routes, Route, Navigate } from "react-router-dom";
import MainPage from "./MainPage";
import CreateReport from "./CreateReport";
import Data from "./WeeklyWaterAndWeather/Data";
function ProtectedRoute({ children }) {
  const isAuthenticated = sessionStorage.getItem("token") !== null;

  return isAuthenticated ? children : <Navigate to="/login" />;
}

export default function ReportRoutes() {
  return (
    <div>
      <Routes>
        {/* Weekly Water and Weather Report */}
        <Route
          exact
          path="/reports"
          element={
            <ProtectedRoute>
              <MainPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/create-report"
          element={
            <ProtectedRoute>
              <CreateReport />
            </ProtectedRoute>
          }
        />

        <Route
          path="/weekly-water-and-weather-data"
          element={
            // <ProtectedRoute>
            <Data />
            // </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}
